import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "column is-one-quarter" }
const _hoisted_2 = { class: "column is-three-quarter content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Sidebar = _resolveComponent("Sidebar")!
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createElementBlock("main", {
    class: _normalizeClass(["columns is-gapless is-multiline", { 'dark-mode': _ctx.isDarkModeOn }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Sidebar, { onThemeChanged: _ctx.toggleTheme }, null, 8, ["onThemeChanged"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_RouterView)
    ])
  ], 2))
}